import { PropsWithChildren } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { useLocation, useParams } from 'react-router-dom';
import { PageLink } from '@/components/TopPageLinks';
import JobPagesContext from '@/contexts/jobPagesContext';
import useApiFetch from '@/hooks/useApiFetch';
import jobServices from '@/services/jobs';
import { chakraExtendedTheme } from '@/styles/theme';
import { FetchApiIds } from '@/types';
import { Paths } from '@/types/routes';
import JobPageComponent from './Job.component';

type Props = PropsWithChildren;

const JobPage = (props: Props): JSX.Element => {
  const { jobId = '' } = useParams();
  const location = useLocation();

  const {
    data: job,
    refetch,
    isLoading,
  } = useApiFetch([FetchApiIds.JOBS_DETAILS, jobId], async () =>
    jobServices.getJobByID(jobId as string)
  );

  const topPageLinks: PageLink[] = [
    {
      label: 'Overview',
      to: {
        path: Paths.JOB_DETAILS,
        params: {
          jobId,
        },
      },
      isActived: location.pathname === Paths.JOB_DETAILS.replace(':jobId', jobId),
    },
    {
      label: 'Candidates',
      to: {
        path: Paths.JOB_CANDIDATES,
        params: {
          jobId,
        },
      },
      isActived: location.pathname === Paths.JOB_CANDIDATES.replace(':jobId', jobId),
    },
    {
      label: 'Notes',
      to: {
        path: Paths.JOB_NOTES,
        params: {
          jobId,
        },
      },
      isActived: location.pathname === Paths.JOB_NOTES.replace(':jobId', jobId),
    },
  ];

  return (
    <ChakraProvider theme={chakraExtendedTheme}>
      <JobPagesContext.Provider value={{ job, refetchJob: refetch, isLoadingJob: isLoading }}>
        <JobPageComponent topPageLinks={topPageLinks} job={job} {...props} />
      </JobPagesContext.Provider>
    </ChakraProvider>
  );
};

export default JobPage;
